import { DASH, M3U8, MP4, WEBM } from 'constants/mimes';
import { getDashPlaylistWithCredentials } from 'utilities/dash';
import { getHlsPlaylistWithCredentials } from 'utilities/hls';
import * as logger from 'utilities/loggerx';
import * as videoUtils from 'utilities/video';

interface VideoPlayerSourceProperties {
  source_url: string | null;
  source_mime_type: string | null;
  source_url_is_transcoded: boolean;
  // TODO (weave) change this type
  source_part_credentials: unknown;
}

export const getClipSourceUrl = async ({
  // @ts-expect-error ignore due to enabling strict null checks
  clip = null,
  forceOriginal = false,
}: {
  clip?: { id: string; root_video_id: string };
  forceOriginal?: boolean;
} = {}): Promise<VideoPlayerSourceProperties | undefined> => {
  try {
    // TODO (weave): When we update thumbnails then we can get the poster url
    // const posterUrl = videoUtils.getPosterUrl(video);

    if (!clip) {
      return;
    }

    const clipId = clip.id;

    const { partCredentials, sourceMimeType, sourceUrl } = await new Promise(
      resolve => {
        let sourceMimeType;

        // TODO (weave): support multiple mimetyps when applicable
        // supportedMimeTypes = videoUtils.getSupportedMimeTypes();
        const supportedMimeTypes = [M3U8];

        const getUrlHandler = videoUtils.postSessionRawURL;

        getUrlHandler(
          clip.root_video_id,
          // TODO (weave): figure out password to pass in
          null,
          (sourceUrl, partCredentials = {}) => {
            const a = document.createElement('a');

            a.href = sourceUrl;

            if (a.pathname.endsWith('.mp4')) {
              sourceMimeType = MP4;
            } else if (a.pathname.endsWith('.webm')) {
              sourceMimeType = WEBM;
            } else if (a.pathname.endsWith('.m3u8')) {
              sourceMimeType = M3U8;
            } else if (a.pathname.endsWith('.mpd')) {
              sourceMimeType = DASH;
            }

            resolve({ partCredentials, sourceMimeType, sourceUrl });
          },
          forceOriginal,
          supportedMimeTypes,
          clipId
        );
      }
    );

    const finalSourceUrl = await (() => {
      if (Object.keys(partCredentials).length === 0) {
        return sourceUrl;
      }

      if (sourceMimeType === M3U8) {
        // take the m3u8 playlist url, download it, and then use the part credentials
        // to create a blob URL of a modified playlist with the credentials attached
        return getHlsPlaylistWithCredentials(sourceUrl, partCredentials);
      } else if (sourceMimeType === DASH) {
        return getDashPlaylistWithCredentials(sourceUrl, partCredentials);
      }

      return sourceUrl;
    })();

    // TODO (Weave): When we update thumbnails then we can get the poster url
    // if (posterUrl) {
    //   dispatch(updateVideoPlayerPosterUrl(posterUrl));
    // }

    const sourceUrlIsTranscoded = sourceUrl.includes('/sessions/transcoded/');

    return {
      source_url: finalSourceUrl,
      source_mime_type: sourceMimeType,
      source_part_credentials: partCredentials,
      source_url_is_transcoded: sourceUrlIsTranscoded,
    };
  } catch (err) {
    logger.error(
      err,
      { message: `Error retrieving source url for clip id ${clip.id}` },
      { team: logger.CREATE_TEAM, clipId: clip.id, videoId: clip.root_video_id }
    );
  }
};
